import { useEffect } from "react"

import { UtilHelper } from "../helpers/util.helper"

export const useScrollFix = () => {
    useEffect(() => {
        UtilHelper.scrollToPageTop()
    }, [])
}
